import { render, staticRenderFns } from "./ExportSettings.vue?vue&type=template&id=5a7b642b&scoped=true&"
import script from "./ExportSettings.vue?vue&type=script&lang=js&"
export * from "./ExportSettings.vue?vue&type=script&lang=js&"
import style0 from "./ExportSettings.vue?vue&type=style&index=0&id=5a7b642b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b642b",
  null
  
)

export default component.exports